import { createContext, useContext } from 'react'
import { Participant } from 'twilio-video'

import { LocalTrackData } from '../components/calls/tracks/use_local_tracks'

export type ParticipantManagerType = {
  allParticipants?: { [index: string]: Participant }
  localParticipant?: Participant
  localTrackData?: LocalTrackData
  remoteParticipants?: Participant[] | undefined
  remoteParticipantsWithVideo?: Participant[] | undefined
  autoNav?: () => void
  isVideoActive?: boolean
}

export const ParticipantManagerContext = createContext<ParticipantManagerType>(
  {},
)

export const useParticipantManager = () => {
  return useContext(ParticipantManagerContext)
}
